import * as H from "history";
import { CommandBarButton, MessageBarType } from "office-ui-fabric-react";
import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { GetUploadStatusDTO } from "../../../../models/SdsUploadStatus";
import Actions from "../../../../redux/Actions";
import { IRootState } from "../../../../store";
import DispatchProps from "../../../../utils/DispatchProps";
import ApiService from "../../../ApiService";
import LoadingCard from "../../../LoadingCard";
import MailroomDurableFunctionInstanceHistory from "../../../mailroom/MailroomDurableFunctionInstanceHistory";
import MailroomDurableFunctionInstanceList from "../../../mailroom/MailroomDurableFunctionInstanceList";
import { openFileDownload } from "../../../../utils/Utils";
import PageTitle from "../../../PageTitle";

interface SdsUploadPageProps {
    tenantId: string;
    uploadId: string;
    apiService: ApiService;
}

interface SdsUploadPageState {
    uploadStatusDTO?: GetUploadStatusDTO | null
    downloadingCsvs: boolean;
}

class SdsUploadPage extends Component<SdsUploadPageProps & DispatchProps, SdsUploadPageState> {

    constructor(props: SdsUploadPageProps & DispatchProps) {
        super(props);

        this.state = { 
            uploadStatusDTO: undefined,
            downloadingCsvs: false
        };
    }

    async componentDidMount() {
        await this.load();
    }

    async componentDidUpdate(prevProps: Readonly<SdsUploadPageProps & DispatchProps>, prevState: any): Promise<void> {
        if (this.props.uploadId !== prevProps.uploadId) {
            await this.load();
        }
    }


    private async load() {
        try {
            this.setState({ uploadStatusDTO: undefined });
            let response = await this.props.apiService.getSdsUploadStatus(this.props.uploadId);
            this.setState({ uploadStatusDTO: response });
        }
        catch (e) {
            this.setState({ uploadStatusDTO: null });
            console.log(e);
            this.props.dispatch(Actions.showMessageBar(`Error loading upload data`, MessageBarType.error));
        }
    }


    private getCSV = async () => {
        try {
            if (this.state.downloadingCsvs) {
                return;
            }

            this.setState({ downloadingCsvs: true });

            const result = await this.props.apiService.getUploadsSdsCSV(this.props.uploadId);

            await openFileDownload(result)

            this.props.dispatch(Actions.showMessageBar(`Succesfully got CSVs`, MessageBarType.success));
            this.setState({ downloadingCsvs: false });
        }
        catch (e) {
            console.log(e);
            this.props.dispatch(Actions.showMessageBar(`Error getting CSVs`, MessageBarType.error));
            this.setState({ downloadingCsvs: false });
        }
    }

    render() {
        switch (this.state.uploadStatusDTO) {
            case undefined:
                return <LoadingCard />;
            case null:
                return <div>Error loading upload data</div>
            default:
                return <Fragment>
                    <PageTitle title="SDS Upload" />
                    <MailroomDurableFunctionInstanceList title={"Upload"} columns={MailroomDurableFunctionInstanceList.uploadColumns} instances={[this.state.uploadStatusDTO.UploadFunctionInstance]} enableRowLinks={false}>
                    </MailroomDurableFunctionInstanceList>
                    <MailroomDurableFunctionInstanceList title={"Processors in this upload"} columns={MailroomDurableFunctionInstanceList.processorColumns} additionalCellForColumn={MailroomDurableFunctionInstanceList.processorAdditionalCellForColumn} instances={this.state.uploadStatusDTO.ProcessorsFunctionInstances} enableRowLinks={true} linkForInstance={(dfi) => `/cdb-admin/mailroom/salamander/${this.props.tenantId}/${dfi.input.processorConfig.schoolCode}/process/${dfi.durableFunctionInstanceId}`}>
                        <CommandBarButton
                            iconProps={{ iconName: "download" }}
                            text="Download CSVs from upload snapshot"
                            disabled={this.state.downloadingCsvs === true}
                            onClick={this.getCSV}
                        />
                    </MailroomDurableFunctionInstanceList>
                    <MailroomDurableFunctionInstanceHistory title={"Upload function history"} instanceId={this.state.uploadStatusDTO.UploadFunctionInstance.durableFunctionInstanceId}/>
                </Fragment>;
        }
    }
}

export default connect(
    (state: IRootState, ownProps: { history: H.History, match: any }): SdsUploadPageProps => {
        return {
            tenantId: ownProps.match.params.tenantId,
            uploadId: ownProps.match.params.uploadId,
            apiService: state.auth.apiService
        };
    }
)(SdsUploadPage);